import {AfterViewInit, Component, OnInit} from '@angular/core';
import {User} from '../../../dto/user';
import {ReplaySubject, Subject} from 'rxjs';
import {FormControl} from '@angular/forms';
import {TrackingLocation} from '../../../dto/tracking-location';
import {Market} from '../../../dto/market';
import {MarketLevel} from '../../../dto/market-level';
import {ActivatedRoute} from '@angular/router';
import {BaseService} from '../../../services/base.service';
import {AuthService} from '../../../services/auth.service';
import {MatSelectChange, MatTabChangeEvent} from '@angular/material';
import swal from 'sweetalert2';
import {UserRole} from '../../../dto/user-role';
import {Endpoints} from '../../../config/endpoints';
import {BaseDatasourceService} from '../../../services/base-datasource.service';
import {UserTimeline} from '../../../dto/user-timeline';
import {GeneralBroadcastService} from '../../../services/general-broadcast.service';
import {takeUntil} from 'rxjs/operators';
import {MarketService} from '../../../services/market.service';

@Component({
    selector: 'app-get-last-location',
    templateUrl: './get-last-location.component.html',
    styleUrls: ['./get-last-location.component.scss']
})
export class GetLastLocationComponent implements OnInit, AfterViewInit {

    lat = 0.0;
    lng = 0.0;

    loggedUser: User;

    locationList: TrackingLocation[] = [];
    loadingData = false;
    markets = [];
    selectedMarket: Market[] = [];
    marketLevels: MarketLevel[] = [];
    userRoles: UserRole[];
    userRole = new UserRole();
    filters = {
        'MarketIdList': null,
        'Only': null,
        'SearchKey': null,
        'UserRoleId': null,
        FileType: null

    };

    userType = 'ORGANIZATION_USER';
    userList: User[] = [];
    filteredUserList: ReplaySubject<User[]> = new ReplaySubject<User[]>(1);
    userFilter: FormControl = new FormControl();

    selectedTab = 'map';
    dataSource: BaseDatasourceService<UserTimeline>;
    displayedColumns = ['SN', 'UserName', 'UserCode', 'UserRole', 'LocationTime', 'Latitude', 'longitude', 'Address', 'IMEI'];
    showMarketFilters = [];
    title = 'web_';

    marketHierarchyLength = 0;
    marketIndex = 0;
    marketLoading = false;
    marketLevelId = null;
    filteredMarketList = [];
    marketFilterForm: FormControl = new FormControl();

    filterTitle = '_webFilter';
    saveFilterTitle = '_webFilterSave';
    showPreferences = false;
    showFilters = false;
    userRank: number;

    showUserRoleFilter = true;

    private _unsubscribeAll: Subject<any>;
    private isSelected: boolean;
    private isSelected1: boolean;
    private filename: string;
    private filetype: string;

    constructor(private route: ActivatedRoute, private service: BaseService, private auth: AuthService, private generalBroadcastService: GeneralBroadcastService, private marketService: MarketService ) {
        this._unsubscribeAll = new Subject();
        this.generalBroadcastService.broadcastTitle('User Last Location Tracking');
        this.generalBroadcastService.broadcastSelectedModuleId('LOCATION');
        this.loggedUser = auth.user;
        this.marketLevels = marketService.marketLevels;
        this.marketLevels.forEach(pMarketLevel => {
            this.markets[pMarketLevel.Rank] = [];
            this.selectedMarket[pMarketLevel.Rank] = null;
            this.showMarketFilters.push(true);
            const filteredMarket: ReplaySubject<Market[]> = new ReplaySubject<Market[]>(1);
            this.filteredMarketList.push(filteredMarket);
        });
        this.userRank = marketService.userRank;
        this.selectedMarket = this.marketService.prepareUserMarket();

    }

    ngOnInit(): void {
        this.marketFilterForm.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (!this.markets[this.marketIndex]) {
                return;
            }

            const search = this.marketFilterForm.value;
            if (!search) {
                this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].slice());
                return;
            }

            this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].filter(product => product.Name.toLowerCase().indexOf(search.toLowerCase()) > -1 || product.Code.toLowerCase().indexOf(search.toLowerCase()) > -1));
        });

        this.service.getUserRoleList({}).subscribe(pUserRoles => this.userRoles = pUserRoles);
        this.dataSource = new BaseDatasourceService<UserTimeline>(this.service);
        // this.getLocationList();
        this.getFilters();
        this._getPreferredFilters();
    }

    ngAfterViewInit(): void {

    }

    filterMarkets(): void {
        this.marketLevels.forEach((pMarketLevel, index) => {
            this.service.getMarketMiniList(pMarketLevel.Id).subscribe(pResponse => {
                this.markets[pMarketLevel.Rank] = pResponse;
                this.filteredMarketList[index].next(this.markets[pMarketLevel.Rank].slice());
            });
        });
    }

    marketFilterChangeListener(pEvent: MatSelectChange): void {
        const selectedMarkets = [];
        this.marketLevels.forEach(pMarketLevel => {
            selectedMarkets[pMarketLevel.Rank] = null;
        });
        let rank = 0;
        if (pEvent.value) {
            this.service.getMarketDetails(pEvent.value.Id).subscribe(pMarket => {
                if (pMarket.ParentList) {
                    for (let i = pMarket.ParentList.length - 1; i >= 0; i--) {
                        selectedMarkets[pMarket.ParentList[i].MarketLevel.Rank] = pMarket.ParentList[i];
                        rank = pMarket.ParentList[i].MarketLevel.Rank;
                    }
                    selectedMarkets[rank + 1] = pMarket;
                    this.selectedMarket = selectedMarkets;
                } else {
                    for (let i = 0; i < selectedMarkets.length; i++) {
                        if (pMarket.MarketLevel.Rank == i) {
                            selectedMarkets[i] = pMarket;
                        }
                    }
                    this.selectedMarket = selectedMarkets;
                }
            });
        } else {
            for (let i = this.marketLevelId; i <= this.marketLevels.length; i++) {
                this.selectedMarket[i] = null;
            }
            if (this.userRank > 1) {
                let selectedMarket = new Market();
                for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
                    if (this.selectedMarket[i]) {
                        selectedMarket = this.selectedMarket[i];
                        break;
                    }
                }
                if (selectedMarket.MarketLevel) {
                    if (selectedMarket.MarketLevel.Rank < this.userRank) {
                        for (let i = 0; i < this.selectedMarket.length; i++) {
                            this.selectedMarket[i] = null;
                        }
                    }
                }
            }
        }
    }

    getMarketLevel(marketLevel: MarketLevel): void {
        this.marketIndex = marketLevel.Rank;
        const marketLevelId = marketLevel.Id;
        this.marketLevelId = marketLevel.Rank;
        let marketId = null;
        let market = new Market();

        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                marketId = this.selectedMarket[i].Id;
                market = this.selectedMarket[i];
                break;
            }
        }

        if (marketId && marketLevelId != market.MarketLevel.Id && marketLevel.Rank > market.MarketLevel.Rank) {
            this.service.getMarketMiniList(marketLevelId, marketId).subscribe(pResponse => {
                this.markets[this.marketIndex] = pResponse;
                this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].slice());
            });
        }

    }

    switchTabs(): void {
        if (this.showPreferences) {
            this.showPreferences = false;
            this.showFilters = true;
        } else {
            this.showPreferences = true;
            this.showFilters = false;
        }
    }

    openFilterModal(pString: string): void {
        if (pString == 'filter') {
            this.showFilters = true;
            this.showPreferences = false;
        }
        if (pString == 'preference') {
            this.showPreferences = true;
            this.showFilters = false;
        }
        const modal = document.getElementById('filterModal');
        modal.style.display = 'block';
    }

    closeFilterModal(isPreference?: boolean): void {
        const modal = document.getElementById('filterModal');
        if (isPreference) {
            this.setFilters();
        }
        modal.style.display = 'none';
    }


    compareMarkets(pMarket1: Market, pMarket2: Market): boolean {
        return pMarket1 && pMarket2 && pMarket1.Id === pMarket2.Id;
    }

    compareById(pData1, pData2): boolean {
        return pData1 && pData2 && pData1 == pData2;
    }

    getFilters(): void {
        const tempMarketFilters = [];
        this.marketLevels.forEach(pMarketLevel => {
            if (localStorage.getItem(this.filterTitle + pMarketLevel.Name) != null) {
                tempMarketFilters.push(localStorage.getItem(this.filterTitle + pMarketLevel.Name) == 'true');
            }
        });
        if (tempMarketFilters.length > 0) {
            this.showMarketFilters = tempMarketFilters;
        }

        if (localStorage.getItem(this.filterTitle + 'UserRole') != null) {
            this.showUserRoleFilter = localStorage.getItem(this.filterTitle + 'UserRole') == 'true';
        }
    }

    setFilters(): void {
        this.marketLevels.forEach((pMarketLevel, index) => {
            localStorage.setItem(this.filterTitle + pMarketLevel.Name, this.showMarketFilters[index] ? 'true' : 'false');
        });
        localStorage.setItem(this.filterTitle + 'UserRole', this.showUserRoleFilter ? 'true' : 'false');


    }

    _getPreferredFilters(): void {
        let marketIndex = null;
        if (localStorage.getItem(this.saveFilterTitle + 'Market')) {
            this.selectedMarket = JSON.parse(localStorage.getItem(this.saveFilterTitle + 'Market'));
        }
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                marketIndex = i;
                break;
            }
        }

        if (marketIndex) {
            for (let i = 1; i < this.selectedMarket.length; i++) {
                if (this.selectedMarket[i]) {
                    const marketLevelId = this.selectedMarket[i].MarketLevel.Id;
                    let marketId;
                    if (i == 1 || this.selectedMarket[i].MarketLevel.Rank <= this.userRank) {
                        marketId = null;
                    } else {
                        marketId = this.selectedMarket[i - 1].Id;

                    }
                    this.service.getMarketMiniList(marketLevelId, marketId).subscribe(pResponse => {
                        this.markets[this.selectedMarket[i].MarketLevel.Rank] = pResponse;
                        this.filteredMarketList[this.selectedMarket[i].MarketLevel.Rank - 1].next(this.markets[this.selectedMarket[i].MarketLevel.Rank].slice());
                    });
                }

            }
        } else {
            this.filterMarkets();
        }
        if (localStorage.getItem(this.saveFilterTitle + 'UserRole') != null) {
            this.filters.UserRoleId = JSON.parse(localStorage.getItem(this.saveFilterTitle + 'UserRole'));
        } else {
            this.filters.UserRoleId = null;
        }
        this.getLocationList();
    }

    _setPreferredFilters(): void {
        localStorage.setItem(this.saveFilterTitle + 'Market', JSON.stringify(this.selectedMarket));
        localStorage.setItem(this.saveFilterTitle + 'UserRole', this.filters.UserRoleId ? JSON.stringify(this.filters.UserRoleId) : null);
    }

    resetParameters(): void {
        for (let i = 0; i < this.selectedMarket.length; i++) {
            if (this.userRank) {
                if (this.selectedMarket[i] &&
                    this.selectedMarket[i].MarketLevel.Rank > this.userRank) {
                    this.selectedMarket[i] = null;
                }
            } else {
                if (this.selectedMarket[i]) {
                    this.selectedMarket[i] = null;
                }
            }
        }

        this.filters.UserRoleId = null;

    }

    // getLocationList(): void {
    //     this.filters.MarketIdList = null;
    //     for ( let i = this.selectedMarket.length - 1; i >= 0; i-- ) {
    //         if ( this.selectedMarket[ i ] ) {
    //             this.filters.MarketIdList = [ this.selectedMarket[ i ].Id ];
    //             break;
    //         }
    //     }
    //
    //     this.loadingData = true;
    //     this.service.getUserLastLocationListV2( this.filters ).subscribe( locationList => {
    //         this.loadingData = false;
    //         if ( locationList.length > 0 ) {
    //             this.lat = locationList[ 0 ].Latitude;
    //             this.lng = locationList[ 0 ].Longitude;
    //         }
    //
    //         this.locationList = locationList;
    //     }, error => {
    //         this.loadingData = false;
    //     } );
    // }

    downloadReport(): void {
        swal({
            title: 'Download Report',
            html:
                '<div class="example-container"><mat-form-field><input matInput id="report" placeholder="Enter report name"' +
                '></mat-form-field><br><br>' +
                '<div class="container">\n' +
                '<div class="col-md-12">' +
                '<input class="col-xs-3" type="radio" value="CSV" id="input1" name="filetype" checked> CSV' +
                '<input class="col-xs-4 col-xs-offset-4" name="filetype" type="radio" value="XLSX" id="input2" style="margin-left: 20px;"> XLSX ' +
                '</div>\n' +
                '</div><div>',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Download',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                swal.disableConfirmButton();
                this.isSelected = (<HTMLInputElement>document.getElementById('input1')).checked;

                this.isSelected1 = (<HTMLInputElement>document.getElementById('input2')).checked;
                if (this.isSelected || this.isSelected1) {
                    swal.enableConfirmButton();
                } else {
                    swal.disableConfirmButton();
                }
                this.filename = (<HTMLInputElement>document.getElementById('report')).value;
                if (this.isSelected) {
                    this.filetype = (<HTMLInputElement>document.getElementById('input1')).value;
                } else if (this.isSelected1) {
                    this.filetype = (<HTMLInputElement>document.getElementById('input2')).value;
                }
                this.filters.FileType = this.filetype;
                window.location.href = this.service.generateGetUrl(Endpoints.user_last_location_list_v2_export, this.filters, this.filename, true);
            },

            allowOutsideClick: () => !swal.isLoading()
        });
    }


    getLocationList(): void {
        this.filters.MarketIdList = null;
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                this.filters.MarketIdList = [this.selectedMarket[i].Id];
                break;
            }
        }
        this.loadingData = true;
        this.service.getUserLastLocationListV2(this.filters).subscribe(locationList => {
            this.loadingData = false;
            if (locationList.length > 0) {
                this.lat = locationList[0].Latitude;
                this.lng = locationList[0].Longitude;
            }

            this.locationList = locationList;
        }, error => {
            this.loadingData = false;
        });
    }
    tabChangeListener(pString: string): void {
        this.dataSource = new BaseDatasourceService<UserTimeline>( this.service );

        if (pString == 'map') {
            this.selectedTab = 'map';
            this.getLocationList();
        }
        if (pString == 'List') {
            this.selectedTab = 'List';
            this.reloadDatatable();
        }

    }

    reloadDatatable(): void {
        this.filters.MarketIdList = null;
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                this.filters.MarketIdList = [this.selectedMarket[i].Id];
                break;
            }
        }
        this.dataSource.fetchRemoteData(Endpoints.user_last_location_list_v2, this.filters);

    }


}
